import ProjectProperties from "./project-properties"
import {ProjectSystemType} from "../types"
import ProjectTagProperties from "./tag/tag-properties"
import ProjectPageProperties from "./page/page-properties"
import ProjectGroupProperties from "./group/group-properties"
import ProjectDefaultProperties from "./default/default-properties"
import ProjectLinkProperties from "./link/link-properties"
import ProjectEmbedProperties from "./embed/embed-properties"
import ProjectViewProperties from "./view/view-properties"
import ProjectWorkspaceProperties from "./workspace/workspace-properties"
import ProjectReportViewProperties from "./report/report-view-properties";
import ProjectSession from "../project-session";

export default class ProjectPropertiesFactory {

    static get(projectSystemType: ProjectSystemType, properties:any, project:ProjectSession): ProjectProperties {
        const PropertiesClass    = ProjectPropertiesFactory.getClass(projectSystemType)
        return new PropertiesClass(properties, project)
    }

    static getClass(projectSystemType:ProjectSystemType): typeof ProjectProperties {

        switch (projectSystemType) {
            case ProjectSystemType.TAG:
                return ProjectTagProperties

            case ProjectSystemType.PAGE:
                return ProjectPageProperties


            case ProjectSystemType.CATEGORY:
                return ProjectGroupProperties

            case ProjectSystemType.LINK:

                return ProjectLinkProperties

            case ProjectSystemType.EMBED:
                return ProjectEmbedProperties

            case ProjectSystemType.WORKSPACE:
                return ProjectWorkspaceProperties

            case ProjectSystemType.VIEW:
                return ProjectViewProperties

            case ProjectSystemType.REPORT_VIEW:
                return ProjectReportViewProperties

            case ProjectSystemType.FOLDER:
            case ProjectSystemType.WORKFOLDER:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
            case ProjectSystemType.PROJECT:
                return ProjectDefaultProperties

            default:
                console.log("#kdjieury - po idee this should not happen.. please update cases")
                return ProjectDefaultProperties
        }
    }
}
